import { useEffect } from "react";

function upsert(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function useSeo({ title, description, image, url, type = "article" }) {
  useEffect(() => {
    const prev = document.title;
    if (title) document.title = title;
    upsert("name", "description", description);
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:type", type);
    upsert("property", "og:site_name", "Andres Campos");
    if (url) upsert("property", "og:url", url);
    if (image) upsert("property", "og:image", image);
    upsert("name", "twitter:card", image ? "summary_large_image" : "summary");
    upsert("name", "twitter:title", title);
    upsert("name", "twitter:description", description);
    if (image) upsert("name", "twitter:image", image);
    return () => { document.title = prev; };
  }, [title, description, image, url, type]);
}
